export const boardMeetingMinutesTour = {
  key: "boardMeetingMinutes",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-meetingminutes-search"]',
      content: t("Tour_BoardMeetingMinutes_List"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-meetingminutes-add"]',
      content: t("Tour_BoardMeetingMinutes_Add"),
      placement: "top",
    },
    {
      target: '[data-tour="board-meetingminutes-actions"]',
      content: t("Tour_BoardMeetingMinutes_Actions"),
      placement: "top",
    },
  ],
};
